export default __webpack_public_path__ + "static/media/doge.6d047c4b.svg";